import { Close } from '@mui/icons-material';
import { Box, Modal, Slide, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const FlyoutContainer = ({ isOpen = false, handleClose, children }) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'), {
    noSsr: true,
  });
  const [isMobileBreakpoint, setIsMobileBreakpoint] = useState(isSmallScreen);
  useEffect(() => {
    if (!isSmallScreen) {
      setIsMobileBreakpoint(false);
    } else {
      setIsMobileBreakpoint(true);
    }
  }, [isSmallScreen]);

  return (
    <Modal
      keepMounted
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={isOpen}
      onClose={handleClose}
      sx={{ border: 'none' }}>
      <Slide
        direction={isMobileBreakpoint ? 'up' : 'left'}
        in={isOpen}
        mountOnEnter
        unmountOnExit>
        <Box
          sx={{
            position: 'absolute',
            top: { sm: 24, xs: 88 },
            right: { sm: 24, xs: 'none' },
            bottom: { sm: 24, xs: 0 },
            width: { sm: 800, xs: '100%' },
            boxSizing: 'border-box',
            bgcolor: '#fff',
            p: { sm: 4, xs: 3 },
            borderRadius: { sm: '24px', xs: '24px 24px 0 0' },
            overflowX: 'hidden',
          }}>
          <Box sx={{ position: 'absolute', top: 30, right: 24 }}>
            <Close sx={{ cursor: 'pointer' }} onClick={handleClose} />
          </Box>

          <Box>{children}</Box>
        </Box>
      </Slide>
    </Modal>
  );
};

FlyoutContainer.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node,
};

export default FlyoutContainer;
